export default {
  state: () => ({ 
    EMPLOYEE_LOGGED_IN : false,
    EMPLOYEE_DATA: [],
    EMPLOYEE_CLOCKED_IN: false,
    COMPANY_TIMEZONE: 'America/Denver',
    SELECTED_DEPARTMENT : null,
    TRACKING_USER : false,
    CLOCKED_IN_TASK_UUID : null,
    CLOCKIN_FROM_CURRENT_DEVICE: false    // if user clocked in from this device
  }),
  mutations: {
    SET_EMPLOYEE_DATA(state, data){
      state.EMPLOYEE_DATA = data
    },
    SET_LOGIN_STATE(state, loginState){
      state.EMPLOYEE_LOGGED_IN = loginState
    },
    UPDATE_EMPLOYEE_DATA(state, data){
      let employee = state.EMPLOYEE_DATA
      
      employee[data.key]  = data.value
      state.EMPLOYEE_DATA = employee
    },
    UPDATE_BULK_EMPLOYEE_DATA(state, data){
      let employee = state.EMPLOYEE_DATA
      let updatedEmployee = { ...employee, ...data }
      state.EMPLOYEE_DATA = updatedEmployee
    },
    UPDATE_JWT_TOKEN(state,token){
      state.EMPLOYEE_DATA.token = token
    },
    SET_COMPANY_TIMEZONE(state, data){
      state.COMPANY_TIMEZONE = data
    },
    SET_EMPLOYEE_CLOCKED_IN(state, data){
      state.EMPLOYEE_CLOCKED_IN = data
    },
    SET_SELECTED_DEPARTMENT(state, data){
      state.SELECTED_DEPARTMENT = data
    },
    SET_TRACKING_USER(state, data){
      state.TRACKING_USER = data
    },
    SET_CLOCKED_IN_TASK_UUID(state, data){
      state.CLOCKED_IN_TASK_UUID = data
    },
    SET_CLOCKIN_FROM_CURRENT_DEVICE(state, data){
      state.CLOCKIN_FROM_CURRENT_DEVICE = data
    },
  },
  getters: {
    JWT_TOKEN(state){
      return state.EMPLOYEE_DATA ? state.EMPLOYEE_DATA.token : undefined
    },
    EMPLOYEE_UUID(state){
      return state.EMPLOYEE_DATA ? state.EMPLOYEE_DATA.uuid : undefined
    },
    EMPLOYEE_DATA(state){
      return state.EMPLOYEE_DATA ? state.EMPLOYEE_DATA : undefined
    },

    /***TRN***/
    TIMEZONE(state) {
      let timezone = state.COMPANY_TIMEZONE
      
      if(state.EMPLOYEE_LOGGED_IN && state.EMPLOYEE_DATA && state.EMPLOYEE_DATA.timezone) 
      {
        timezone = state.EMPLOYEE_DATA.timezone
        if(timezone == 'company_timezone') {
          timezone = state.EMPLOYEE_DATA.company.timezone ? state.EMPLOYEE_DATA.company.timezone : 'America/Denver'
        }
      } 

      return timezone
    },
    TIME_FORMAT_DEFAULT(state){
      return state.EMPLOYEE_DATA.admin_time_format && state.EMPLOYEE_DATA.admin_time_format == 'Military' ? 1 : 0;
    },
    /**** #END | TRN ****/
    EMPLOYEE_CLOCKED_IN(state){
      return state.EMPLOYEE_CLOCKED_IN
    },
    SELECTED_DEPARTMENT(state){
      return state.SELECTED_DEPARTMENT ? state.SELECTED_DEPARTMENT : undefined
    },
    TRACKING_USER(state){
      return state.TRACKING_USER ? state.TRACKING_USER : false
    },
    CLOCKED_IN_TASK_UUID(state){
      return state.CLOCKED_IN_TASK_UUID ? state.CLOCKED_IN_TASK_UUID : null
    },
    CLOCKIN_FROM_CURRENT_DEVICE(state){
      return state.CLOCKIN_FROM_CURRENT_DEVICE ? state.CLOCKIN_FROM_CURRENT_DEVICE : false
    },
    EMPLOYEE_COMPANY_UUID(state){
      return state.EMPLOYEE_DATA?.company?.c_uuid ? state.EMPLOYEE_DATA.company.c_uuid : null
    },
    SELECTED_DEPARTMENT_UUID(state){
      return state.SELECTED_DEPARTMENT?.uuid ? state.SELECTED_DEPARTMENT.uuid : null
    }
  },
  actions: {
    
  }
}